import { FEATURES, MODULES } from '../constants/template-info'
import { LocalStorageData } from '../domains/contentful/LocalStorageDataWithExpiry'

import { captureException } from './sentryUtil'

export const getFromLocalStorageWithExpiry = (
  key: string,
  shouldParseJSON = true,
  shouldLogToSentry = true,
): string | null => {
  if (typeof localStorage === 'undefined') return null
  try {
    const now = new Date()
    const val = localStorage.getItem(key)
    if (val) {
      if (!shouldParseJSON) return val
      const data: LocalStorageData = JSON.parse(val)
      if (now.getTime() > data.expiryInMs) {
        localStorage.removeItem(key)
        return null
      }
      return data.value
    }
  } catch (error) {
    console.info('getFromLocalStorageWithExpiry error', error, key)
    if (shouldLogToSentry) {
      captureException('getFromLocalStorageWithExpiry error', {
        module: MODULES.LOCAL_STORAGE,
        feature: FEATURES.GET_FROM_LOCAL_STORAGE_WITH_EXPIRY,
        extraInfo: {
          capturedFrom: 'Get in local storage with expiry function',
          localStorageKey: key,
          errorDetail: JSON.stringify(error),
        },
      })
    }
  }
  return null
}

export const isLocalStorageEnabled = () => {
  const testKey = 'test'
  try {
    localStorage.setItem(testKey, '1')
    localStorage.removeItem(testKey)
    return true
  } catch (error) {
    captureException('Local storage is not enabled', {
      module: MODULES.LOCAL_STORAGE,
      feature: FEATURES.GET_FROM_LOCAL_STORAGE_WITH_EXPIRY,
    })
    return false
  }
}
